let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jaThx")).then(() => parcelRequire('7zGoD'));